<div class="wrapper">
    <div class="title-container">
        <h1>Acompanhe seus projetos em um só lugar!</h1>
        <p>Forecast, a plataforma definitiva para gestão de obras.</p>
    </div>
    
    <div class="image">
        <img src="../../../assets/title-img.png" />
    </div>
</div>